export default __webpack_public_path__ + "static/media/pause-white.593834d1.svg";